module.exports = __webpack_public_path__ + "img/icon_4_16.33fe651e.png";